import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { WhiteTextXs } from 'atoms';

const template = styled.div`
  ${({ theme }) => css`
    padding: 2px 8px;
    display: flex;
    align-items: center;
    border-radius: 20px;
    background: ${theme?.colour?.primary ?? '#1DBD6B'};
    font-size: 12px;
    color: #FFFFFF,
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  `}
`;


export default Molecule({
  template,
  atoms: [
    {
      component: WhiteTextXs,
      name: 'Count',
      displayValue: ({ count }) => `+${count} `,
    },
  ]
})